import * as components from './components'

export default [
  {
    path: '/explore/intro',
    component: components.ExploreIntro,
    name: 'exploreIntro',
    props: true
  },
  {
    path: '/explore/results/career',
    component: components.ExploreCareerResults,
    name: 'exploreCareerResults',
    props: true
  },
  {
    path: '/explore/results/programs',
    component: components.ExploreProgramResults,
    name: 'exploreProgramResults',
    props: true
  },
  {
    path: '/explore/results/insights',
    component: components.ExploreInsightsResults,
    name: 'exploreInsightsResults',
    props: true
  },
  {
    path: '/bookmarks',
    component: components.BookmarkList,
    name: 'bookmarks',
    props: true
  }
]



// WEBPACK FOOTER //
// ./src/app/explore/routes.js